var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 55,
    viewBox: "0 0 61 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON BRAIN"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.7102 53.3618C31.7102 53.3618 33.5831 46.9786 26.5289 44.8428C22.2448 43.5459 17.9648 38.4705 22.7881 33.014C27.6115 27.5576 42.9328 29.8452 42.9036 35.2054C42.8744 40.5655 35.0785 39.868 32.6688 38.2358",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.8002 35.2154C20.8002 35.2154 10.7555 34.5417 11.1787 28.5295C11.6019 22.5172 18.9301 21.6598 26.0871 21.3643C26.0871 21.3643 36.2192 21.0058 39.0172 21.0368C41.8152 21.0678 41.6504 16.3294 41.6504 16.3294",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.969 20.9807C38.969 20.9807 42.3299 21.0789 42.0836 25.1891",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5048 32.9429C13.5048 32.9429 2.15952 35.1618 2.14553 24.9071C2.1344 16.7528 7.49051 17.3089 7.49051 17.3089C7.49051 17.3089 6.66355 6.812 17.7404 8.53547C17.012 2.9951 27.7814 0.70973 30.5803 4.85067C34.1707 0.286671 44.3127 2.52234 44.4769 9.53688C49.0719 7.79953 56.3459 12.1995 53.0672 18.5611C58.8545 19.2761 65.6364 34.1922 41.0578 32.3265",
    stroke: "#EF7056",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9149 15.9737C13.9149 15.9737 21.4208 18.7679 23.5324 12.4694C27.0386 16.221 32.6163 14.8598 34.9057 11.8552",
    stroke: "#EF7056",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrain);
export default __webpack_public_path__ + "static/media/icon-brain.bc4fc6bca30141da3c20bf76226ee563.svg";
export { ForwardRef as ReactComponent };